var _path;
/*
 * The MIT License (MIT)
 *
 * Copyright (c) 2015 - present Instructure, Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */
import { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
class IconMasqueradeLine extends Component {
  constructor(...args) {
    super(...args);
    this.ref = null;
    this.handleRef = el => {
      const elementRef = this.props.elementRef;
      this.ref = el;
      if (typeof elementRef === 'function') {
        elementRef(el);
      }
    };
  }
  render() {
    return _jsx(SVGIcon, {
      ...this.props,
      name: "IconMasquerade",
      viewBox: "0 0 1920 1920",
      elementRef: this.handleRef,
      children: _path || (_path = _jsx("path", {
        d: "M1411.765 0C1213.892 0 1043.915 114.861 960 280.207 876.085 114.861 706.108 0 508.235 0H0v508.235c0 280.207 228.028 508.236 508.235 508.236h903.53c160.49 0 302.117-76.236 395.294-192.678v870.325c0 62.343-50.598 112.94-112.941 112.94-62.344 0-112.942-50.597-112.942-112.94v-564.706h-112.94v564.706c0 124.574 101.308 225.882 225.882 225.882S1920 1818.692 1920 1694.118V0h-508.235ZM903.529 903.53H508.235c-217.976 0-395.294-177.318-395.294-395.295V112.941h395.294c217.977 0 395.294 177.318 395.294 395.294V903.53Zm903.53-395.295c0 217.977-177.318 395.294-395.294 395.294H1016.47V508.235c0-217.976 177.317-395.294 395.294-395.294h395.294v395.294Zm-1298.824 56.47c-73.637 0-136.433-47.209-159.699-112.94h159.7c73.637 0 136.432 47.21 159.698 112.94H508.235Zm0-225.881H225.882v56.47c0 155.746 126.607 282.353 282.353 282.353h282.353v-56.47c0-155.746-126.607-282.353-282.353-282.353Zm621.177 282.352v56.471h282.353c155.746 0 282.353-126.607 282.353-282.353v-56.47h-282.353c-155.746 0-282.353 126.607-282.353 282.352m282.353-56.47h-159.7c23.267-65.732 86.062-112.941 159.7-112.941h159.699c-23.266 65.731-86.062 112.94-159.7 112.94",
        fillRule: "evenodd"
      }))
    });
  }
}
IconMasqueradeLine.glyphName = 'masquerade';
IconMasqueradeLine.variant = 'Line';
IconMasqueradeLine.displayName = 'IconMasqueradeLine';
IconMasqueradeLine.allowedProps = [...SVGIcon.allowedProps];
export default IconMasqueradeLine;
export { IconMasqueradeLine };